import { atom } from "jotai";

export const lastOperationsAtom = atom<any>({
  isFetching: false,
  data: [],
});
